import { isToolUIPart } from 'ai';
import { useRachelChatContext } from '../contexts/Rachel.context';
import { RachelUIMessage } from '../rachel.types';

type RachelPart = RachelUIMessage['parts'][number];

export const usePendingToolApprovals = (): RachelPart[] => {
  const { messages } = useRachelChatContext();
  const lastMessage = messages.at(-1);

  if (!lastMessage || lastMessage.role !== 'assistant') {
    return [];
  }

  return lastMessage.parts.filter(
    (part) => isToolUIPart(part) && part.state === 'approval-requested',
  );
};
